/* eslint-disable  */
import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import styles from './curriculum-view.css';
import { BsChevronRight, BsChevronLeft } from "react-icons/bs";

const CurriculumView = ({ isOpen, content, onContentReady }) => {
    const styleName = isOpen ? 'expanded' : 'colapsed';
    const [viewIndex, setViewIndex] = useState(0);
    const [parsedData, setParsedData] = useState(null);
    
    useEffect(() => {
        const doms = parseDom(content);
        onContentReady();
        setParsedData(doms);
    }, [content]);

    const parseDom = (content) => {
        const parsedBody = new Array(content.length);
        for (var i = 0; i < content.length; i++) {
            var domString = content[i].body;
            domString = domString.replace(/(action-text-attachment)/gm, 'img');
            domString = domString.replace(/(url)/gm, 'src');
            const regH = /(height="...")/gm;
            const regW = /(width="...")/gm;
            domString = domString.replace(regH, 'height=100%');
            domString = domString.replace(regW, 'width=100%');
            parsedBody[i] = domString;
        }
        return parsedBody;
    }

    const handleNext = () => {
        if (viewIndex < parsedData.length - 1) {
            setViewIndex(viewIndex + 1);
        }
    }

    const handleBack = () =>  {
        if (viewIndex > 0) {
            setViewIndex(viewIndex - 1);
        }
    }

    return (
        <div
            onAnimationEnd={() => { window.dispatchEvent(new Event('resize'));}}
            className={styles.content_wrapper + " " + styles[styleName]}>
            { parsedData != null ? [
                <h2 key="curTitle" className={styles.contentTitle}>
                    {content[viewIndex].title}
                </h2>,
                <div key="curBody" className={styles.contentBody}>
                    {parsedData == null ? null : <CurriculumContent content={parsedData[viewIndex]} />}
                </div>,
                <div key="curNav" className={styles.navigation_bar}>
                    { viewIndex != 0 ?
                        <a className={styles.nav_button} onClick={handleBack}>
                            <span className={styles.nav_icon}><BsChevronLeft/></span>
                        </a> : null }
                    { viewIndex != parsedData.length -1 ?
                        <a className={styles.nav_button} onClick={handleNext}>
                            <span className={styles.nav_icon}><BsChevronRight/></span>
                        </a> : null }
                </div>
            ] : null }
        </div>
    )
};



const CurriculumContent = props => {
    return (
        <div dangerouslySetInnerHTML={{ __html: props.content ? props.content : null }} />
    );
}

export default CurriculumView;

